import { Provider } from "react-redux";
import AppRouter from "./routes/AppRouter";
import store from "./redux/store";
import ThemeProvider from "./theme";
import { AlertProvider } from "./hooks/useAlert";
import { SnackbarProvider } from "notistack";
import { styled } from "@mui/material";
import apiConfig from "./services/apiManager/apiConfig";
import { useAppSettings } from "./hooks/useAppSettings";
import { AppMaintenanceTile } from "./components/AppMaintenanceTile";

const StyledSnackbarProvider = styled(SnackbarProvider)`
  & #notistack-snackbar {
    width: 88%;
    z-index: 9999999;
  }
`;

function App() {
  const { appSettings, setAppSettings } = useAppSettings(apiConfig.appSettings);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <AlertProvider>
          <StyledSnackbarProvider
            maxSnack={3}
            autoHideDuration={3000}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            {appSettings?.maintenance && (
              <AppMaintenanceTile appSettings={appSettings} />
            )}
            <AppRouter setAppSettings={setAppSettings} />
          </StyledSnackbarProvider>
        </AlertProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
